<div class="login-body">
  <p-toast position="top-center">
  </p-toast>
  <div class="login-panel">
    <div class="flex-col">
      <div>
        <img src="assets/layout/images/logo-login.png" />
        <h1>Passwort vergessen</h1>
        <h2>{{app.appName}}</h2>
      </div>
      @if (errorMessage != null) {
        <p-message severity="error">{{errorMessage}}</p-message>
      }
      @if (errorMessage == null) {
        <sm-form [form]="form">
        </sm-form>
      }
      <div>
        @if (errorMessage == null) {
          <p-button styleClass="width100p" icon="fas fa-sign-in" [label]="userName == null ? 'Weiter' : 'Abschließen'" (onClick)="send()">
          </p-button>
        }

        @if (running) {
          <div>
            <div>Rücksetzung läuft ...</div>
            <p-progressSpinner></p-progressSpinner>
          </div>
        }
      </div>
    </div>
  </div>
